import "core-js/modules/es.number.constructor.js";
import { paymentTypes, paymentState, paymentStates } from "@/js/lists.ts";
import { formRules } from "@/js/form_rules.js";
export default {
  props: {
    value: Number,
    confirm: Function,
    cancel: Function,
    dialog: Boolean,
    paymentStatus: String,
    paymentIdType: Number,
    order: Object,
    successDate: String,
    reference: String
  },
  data: function data() {
    return {
      isValid: false,
      paymentType: null,
      selectedStatus: null,
      dateMenu: null,
      paymentDate: new Date().formatForDatePickerDays(),
      paymentReference: null,
      isAttachPaymentToAccRecs: false,
      interval: null,
      timeLeft: 0,
      validating: false,
      resolve: null,
      reject: null,
      options: {
        color: "primary",
        width: 600,
        zIndex: 2000
      },
      rules: formRules,
      paymentTypes: paymentTypes,
      paymentState: paymentState,
      paymentStates: paymentStates
    };
  },
  methods: {
    agree: function agree() {
      if (!this.selectedStatus) {
        return;
      }
      var paymentDateSuccess = null;
      if (this.selectedStatus === paymentState.SUCCEEDED) {
        if (!this.paymentDate) {
          return;
        }
        paymentDateSuccess = this.paymentDate;
      }
      this.validating = true;
      var _this = this;
      return this.confirm(this.selectedStatus, this.paymentType, paymentDateSuccess, this.paymentReference, this.isAttachPaymentToAccRecs).then(function () {
        _this.validating = false;
      }).catch(function (e) {
        var _e$response;
        if (e !== null && e !== void 0 && (_e$response = e.response) !== null && _e$response !== void 0 && _e$response.data) {
          _this.$toasted.show(e.response.data.value, {
            type: "warning"
          });
        }
        _this.validating = false;
      });
    },
    internalCancel: function internalCancel() {
      this.selectedStatus = null;
      this.cancel();
    }
  },
  watch: {
    dialog: function dialog() {
      this.selectedStatus = this.paymentStatus;
      this.paymentType = this.paymentIdType;
      this.paymentReference = this.reference;
      if (this.successDate && this.selectedStatus === paymentState.SUCCEEDED) {
        this.paymentDate = new Date(this.successDate).formatForDatePickerDays();
      }
    }
  }
};